import { getBestellenSnippet } from "./api";
import { replaceHtml } from "./helper";

export function loadBestellenSnippet(container, checkoutId) {
  return getBestellenSnippet(checkoutId)
    .then((response) => response.text())
    .then((bestellenJs) => { replaceHtml(container, bestellenJs); })
    .then(wailForStartEvent);
}

function wailForStartEvent() {
  return new Promise((resolve) => { window.addEventListener("checkout-kaufen-start", resolve); });
}
